export default "__VITE_ASSET__CH$01RSN__"